import moment from "moment";
const chrono = require("chrono-node");

const stripTimeAndZone = date => {
  return (date || "").split("T")[0] || date;
};

const convertToMoment = date => {
  return moment(chrono.parseDate(stripTimeAndZone(date)));
};

export { convertToMoment, stripTimeAndZone };
